import { z } from "zod";

export const getArticlesQuerySchema = z.object({
	warehouseLocationId: z.uuid().optional(),
	suborderId: z.uuid().optional(),
});

export type GetArticlesQuerySchema = z.infer<typeof getArticlesQuerySchema>;
